<div class="jw-modal">
        <ng-content *ngIf="!isDelete">

        </ng-content>
        <div class="modal-dialog" style="padding-top:15%" *ngIf="isDelete">
                <div class="modal-content">
                        <div class="modal-header">
                                <h4 class="modal-title" id="myCenterModalLabel">Advertencia!</h4>
                                <button type="button" class="btn-close" (click)="close()"></button>
                        </div>
                        <div class="modal-body">
                                <p class="pl-4"><i
                                                class="pl-2 fas fa-exclamation-circle text-warning  fa-lg fa-2x"></i>&nbsp;
                                        &nbsp; Esta seguro que desea eliminar este registro? </p>
                        </div>
                        <div class="modal-footer">
                                <button type="button" class="btn btn-secondary waves-effect"
                                        (click)="close();">No</button>
                                <button type="button" class="btn btn-primary" (click)="confirm()">Si</button>
                        </div>
                </div>
        </div>
</div>